import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto,
} from '../../services/wealthlane-customer-services';

const useGetParticipantTaxDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Participant_ViewParticipantTaxDto | undefined,
  unknown
> => {
  const participantTaxDetails = useQuery(
    ['getParticipantTaxDetails'],
    async () => {
      return await handleRequest(
        ParticipantService.getApiCustomerApiAppParticipantParticipantTax()
      );
    }
    // {
    //   cacheTime: 1000 * 60 * 5,
    // }
  );

  return participantTaxDetails;
};

export default useGetParticipantTaxDetails;
